import React, { Component } from 'react';
import { connect } from 'react-redux';
import { history } from '../../helpers';
import {
  Grid,
  Button,
  Form,
  Header,
  Image,
  Container
} from 'semantic-ui-react';
import { userActions } from '../../actions/user.actions';
import { settingsActions } from '../../actions/settings.actions';
import { darken } from '../../helpers/color';
import './styles.css';
import { alertActions } from '../../actions/alert.actions';
import qs from 'qs';
import logo from '../../assets/imgs/logo-station.png';

class LoginScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {                
        email: '',
        password: '',
        submitted: false,
        formVisible: true,
        logoUrl: logo,
        localLoginEnabled: false,
    };

    this.handleChangeUsername = this.handleChangeUsername.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    if (localStorage.getItem('token') && localStorage.getItem('me')) {
      history.push('/');
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const theme = JSON.parse(localStorage.getItem('theme'));    
    if (theme && theme.Logo) {
      this.setState({ logoUrl: theme.Logo });
    }

    dispatch(settingsActions.fetchGlobal()).then(() => {
      const { settings } = this.props;
      if (settings && settings.globalSettings && settings.globalSettings.OpenIdAutoLogin && window.location.hash === '#/login') {
        window.location.href = process.env.REACT_APP_BASE_API_URL_REDIRECT + '/openid/authorize';        
      }

      if (window.location.hash === '#/login/___local' || (settings && settings.globalSettings && !settings.globalSettings.DisableLocalLogin)) {
        this.setState({ localLoginEnabled: true });
      }
       
      if (settings && settings.globalSettings && settings.globalSettings.ImageId) {
        this.setState({ logoUrl: `/api/file/data/${settings.globalSettings.ImageId}`});
      }

      if (settings && settings.globalSettings && settings.globalSettings.PrimaryColor) {
        document.documentElement.style.setProperty('--primaryColor', settings.globalSettings.PrimaryColor);      
        document.documentElement.style.setProperty('--primaryColorDark', darken(settings.globalSettings.PrimaryColor, -50));          
        document.documentElement.style.setProperty('--secondaryColor', settings.globalSettings.PrimaryColor);   
      }
    });
    
    var query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (query.token) {      
      localStorage.setItem("token", query.token);
      this.props.dispatch(userActions.me()).then(() => history.push('/'));
    }
  }

  handleChangeUsername = (e) => {
    const { name, value } = e.target;
    this.setState({...this.state,  email: value });
  }

  handleChangePassword = (e) => {
    const { name, value } = e.target;
    this.setState({...this.state,  password: value });
  }

  handleSubmit = event => {
    event.preventDefault();

    const { email, password } = this.state;
    const { dispatch } = this.props;

    if (email && password) {
      dispatch(userActions.login(email, password));
    } else {
      dispatch(alertActions.error("Preencha o usuário e senha"));
    }
  }

  render() {
    const { loggingIn, settings } = this.props;
    const { formVisible, logoUrl, localLoginEnabled } = this.state;
    return (
        <div className="login-wrapper">
          <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
            <Grid.Column style={{ maxWidth: 450 }}>
              <Container textAlign='center'>
                <Image src={logoUrl} centered />
              </Container>
              { settings && settings.globalSettings && settings.globalSettings.OpenIdEnabled && <Button type='button' style={{marginTop: '16px'}} color='grey' fluid size='large' onClick={() => window.location.href=process.env.REACT_APP_BASE_API_URL_REDIRECT + '/openid/authorize'}>
                Acessar com Office365
              </Button>}
              { localLoginEnabled && <Form size='large' onSubmit={this.handleSubmit} loading={loggingIn} style={{marginTop: '16px'}}>
                  <div>
                      <Form.Input fluid icon='user' iconPosition='left' placeholder='Usuário' onChange={this.handleChangeUsername} />
                      <Form.Input fluid icon='lock' iconPosition='left' placeholder='Senha' type='password' onChange={this.handleChangePassword} />
                      <Button type='submit' colr='primary' fluid size='large'>
                          Entrar
                      </Button>
                  </div>
              </Form>}
            </Grid.Column>
          </Grid>
        </div>
    );
  }
}

function mapStateToProps(state) {
  const { settings } = state;
  const { loggingIn } = state.authentication;
  const { users } = state.users;
  return {
    me: users && users.me ? users.me : null,
    loggingIn,
    settings,
  };
}

const connectedLoginScreen = connect(mapStateToProps)(LoginScreen);
export { connectedLoginScreen as LoginScreen };
